import { useJoyride, ORIGIN, STATUS, EVENTS } from "react-joyride"

import { JoyrideMuiTooltip } from "./JoyrideMuiTooltip"

// above MUI AppBar (1100), Drawer (1200) and Modal (1300)
export const TOUR_Z_INDEX = 1401

export const useJoyrideMuiTour = ({
  run,
  steps,
  startIndex = 0,
  onFinish,
  onTargetNotFound = null
}) => {
  const { Tour, controls } = useJoyride({
    continuous: true,
    run,
    steps,
    options: {
      zIndex: TOUR_Z_INDEX,
      blockTargetInteraction: true,
      overlayClickAction: false,
      closeButtonAction: "skip" // ends the tour, default is "close", which advances to the next step
    },
    tooltipComponent: JoyrideMuiTooltip,
    onEvent: (data) => {
      if (data.type === EVENTS.TOUR_START && startIndex > 0) {
        controls.go(startIndex)
        return
      }

      if (data.type === EVENTS.TARGET_NOT_FOUND) {
        onTargetNotFound?.({ index: data.index, step: data.step })

        // Joyride auto-advances past a missing target, so a missing *last* step
        // ends the tour without FINISHED — leaving it forever unseen and
        // resumable. Treat running off the end as completion.
        if (data.index >= data.size - 1) {
          onFinish?.({ index: data.index, completed: true })
        }

        return
      }

      if ([STATUS.FINISHED, STATUS.SKIPPED].includes(data.status)) {
        onFinish?.({
          index: data.index,
          completed:
            data.status === STATUS.FINISHED ||
            data.origin === ORIGIN.BUTTON_SKIP
        })
      }
    }
  })

  return Tour
}
